"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowTastSubmissionArtifactSchema = exports.WorkflowTastSubmissionArtifactPayloadSchema = exports.WorkflowTaskStateSchema = exports.WorkflowFormInputSchema = exports.WorkflowTaskInputSchema = exports.TaskEntitySchema = void 0;
exports.WorkflowTaskSubmitInputSchema = WorkflowTaskSubmitInputSchema;
const zod_1 = __importDefault(require("zod"));
exports.TaskEntitySchema = zod_1.default.object({
    id: zod_1.default.string(),
});
exports.WorkflowTaskInputSchema = zod_1.default.object({
    offer: zod_1.default.string({
        description: 'ID of offer',
    }),
    task: zod_1.default.string({
        description: 'Task key',
    }),
    prompt: zod_1.default.string({
        description: 'Langfuse prompt ID',
    }),
});
exports.WorkflowFormInputSchema = zod_1.default.object({
    // form: z.string({
    //     description: 'Form definition ID',
    // }),
    // prompt: z.string({
    //     description: 'Langfuse prompt ID',
    // }),
    offer: zod_1.default.string({
        description: 'ID of offer',
    }),
    task: zod_1.default.string({
        description: 'Task key',
    }),
    prompt: zod_1.default.string({
        description: 'Langfuse prompt ID',
    }),
});
exports.WorkflowTaskStateSchema = zod_1.default.object({
    prompt: zod_1.default.string({ description: 'The final interview prompt' }),
    form: zod_1.default.string({ description: 'The form ID' }),
});
exports.WorkflowTastSubmissionArtifactPayloadSchema = zod_1.default.object({
    submission: zod_1.default.string({ description: 'ID of the submission' }),
});
exports.WorkflowTastSubmissionArtifactSchema = zod_1.default.object({
    namespace: zod_1.default.literal('form'),
    type: zod_1.default.literal('submission'),
    data: exports.WorkflowTastSubmissionArtifactPayloadSchema,
});
function WorkflowTaskSubmitInputSchema(data) {
    return zod_1.default.object({
        form: zod_1.default.string(),
        data,
    });
}
//# sourceMappingURL=workflowTaskSchema.js.map